module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Summer Lovin\u0027","subtitle":"Summer must have outfits","linkLabel":"Shop collection"},"de":{"title":"Sommer Fashion","subtitle":"Beste Outfits für die Saison","linkLabel":"Jetzt bestellen"}}')
  delete Component.options._Ctor
}
